import { GlobeAltIcon } from "@heroicons/react/24/outline";
import { useEffect, useState, Fragment, Dispatch, SetStateAction } from "react";
import { useRouter } from "next/router";
import MoreInfo from "./moreInfo";
import RiskBadge from "./riskBadge";
import Countries from "./countries";

export default function AnimalCard({
	animal,
	setCountry,
	setAnimal,
}: {
	animal: Animal;
	setCountry: Dispatch<SetStateAction<string>>;
	openIf?: string;
	setAnimal?: Dispatch<SetStateAction<string>>;
}) {
	const router = useRouter();
	const [open, setOpen] = useState(false);

	useEffect(() => {
		if (
			(router.query.animal &&
				!Array.isArray(router.query.animal) &&
				router.query.animal.toLowerCase() === animal.name.toLowerCase()) ||
			(router.query.query &&
				!Array.isArray(router.query.query) &&
				router.query.query.toLowerCase() === animal.name.toLowerCase())
		)
			setOpen(true);
	}, [animal.name, router.query.animal, router.query.query]);

	const moreInfo = () => {
		if (setAnimal) setAnimal(animal.name);
		setOpen(true);
	};

	return (
		<li
			key={`${animal.name}-card`}
			className={`relative col-span-1 divide-y divide-gray-200 rounded-lg border-2 bg-white pb-10 shadow ${animal.level === 5 && "border-red-600"
				}`}>
			<div className="flex w-full items-center justify-between space-x-6 p-6">
				<div className="flex-1 truncate">
					<div className="flex items-center space-x-3">
						<h3 className="truncate text-sm font-medium text-gray-900">
							{animal.name} ({animal.commonName})
						</h3>
						<RiskBadge level={animal.level} />
					</div>
					<p className="my-auto mt-1 max-h-16 overflow-auto text-sm text-gray-500">
						<Countries countries={animal.countries} setCountry={setCountry} />
					</p>
				</div>
			</div>
			<div className="absolute bottom-0 w-full">
				<div className="border-t-1 flex border-gray-200">
					<button
						onClick={moreInfo}
						className="relative inline-flex w-0 flex-1 items-center justify-center rounded-b-lg border border-transparent py-4 text-sm font-medium text-gray-700 hover:bg-gray-100 hover:text-gray-500">
						<GlobeAltIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
						<span className="ml-3">More Info</span>
					</button>
				</div>
			</div>
			<MoreInfo animal={animal} open={open} setOpen={setOpen} setCountry={setCountry} />
		</li>
	);
}
